/*eslint-disable */
import React, { useState, useCallback, useEffect } from 'react';
import { connect } from 'dva';
import { ListView, Toast } from 'antd-mobile';
import copy from 'copy-to-clipboard';
import { hideToast, showLoadingToast } from '@/utils/utils';
import { jsShowAppReviewDialog, openNewWebview } from '@/utils/bridge';
import { reportClick, reportPage, reportPop } from '@/utils/report';
import { useMounted } from '@/utils/hooks';
import CustomModal from '@/components/CustomModal';
import CardStatusTabs from '../components/StatusTabs';
import NoData from '../components/NoData';
import DeviceModal from './components/DeviceModal';
import {
  PAGE_SIZE,
  USING_STATUS,
  BTN_TEXT_MAP,
  UNUSED_STATUS,
  SHOW_RED_DOT,
  HIDE_RED_DOT,
  MODULE,
  ALL_STATUS,
} from '../config';
import styles from '../styles/welfare.less';
import RecommendBonusCard from '@/pages/rights/welfare/components/RecommendCard';

export const PAGE_NAME = 'welfare_code';

const WelfareCard = ({ rights: { rightList, isRightListAll, deviceList }, loading, dispatch }) => {
  // 当前点击绑定的设备
  const [curDevice, setCurDevice] = useState(null);
  // 当前使用的福利码
  const [curWelfareCard, setCurWelfareCard] = useState('');
  // 绑定提示弹窗
  const [isShowConfirm, setShowConfirm] = useState(false);
  // 选择设备弹窗
  const [isShowDeviceModal, setShowDeviceModal] = useState(false);
  // 列表筛选项
  const [filterOptions, setFilterOptions] = useState({
    page: 1,
    page_size: PAGE_SIZE,
    code_status: ALL_STATUS,
  });

  const [adData, setAdData] = useState([]);

  let dataSource = new ListView.DataSource({ rowHasChanged: (r1, r2) => r1 !== r2 });
  dataSource = dataSource.cloneWithRows(rightList);

  const renderListFooter = useCallback(() => {
    let footerText = '';
    if (loading) footerText = '加载中...';
    if (isRightListAll) footerText = '- 没有更多啦 -';
    return <div style={{ textAlign: 'center' }}>{footerText}</div>;
  }, [isRightListAll, loading]);

  const handleUseCard = useCallback((e, cardInfo) => {
    e.stopPropagation();
    console.log('点击使用福利码', cardInfo);
    reportClick({
      page_name: PAGE_NAME,
      button_name: 'use_btn',
    });
    // if (cardInfo.code_status !== UNUSED_STATUS) return;
    setCurWelfareCard(cardInfo);
    showLoadingToast();
    dispatch({
      type: 'rights/checkWelfareCodeLimit',
      payload: {
        right_id: cardInfo.right_id,
        active_code: cardInfo.active_code,
      },
      callback: () => {
        hideToast();
        setShowDeviceModal(true);
      },
    });
  }, []);

  const handleUpdateCardInfo = useCallback((index, info) => {
    dispatch({
      type: 'rights/updateCardInfo',
      payload: {
        index,
        info,
      },
    });
  }, []);

  const handleJumpToDetail = useCallback((index, id) => {
    console.log('跳转至福利卡详情');
    handleUpdateCardInfo(index, {
      red_dot: HIDE_RED_DOT,
    });
    openNewWebview({ url: `${window.location.origin}/rights/detail/${id}` });
  }, []);

  const handleCopyCode = useCallback((e, code) => {
    e.stopPropagation();
    copy(code);
    Toast.info('福利码已复制');
    reportClick({
      page_name: PAGE_NAME,
      button_name: 'copy_btn',
    });
  }, []);

  const handleListEndReached = useCallback(() => {
    if (isRightListAll || loading) return;
    console.log('到底啦');
    setFilterOptions({
      ...filterOptions,
      page: filterOptions.page + 1,
    });
  }, [isRightListAll, filterOptions, loading]);

  const getWelfareCodeList = useCallback(() => {
    console.log('当前筛选项', filterOptions);
    dispatch({
      type: 'rights/getWelfareCodeList',
      payload: {
        ...filterOptions,
      },
      callback: () => {
        hideToast();
      },
    });
  }, [filterOptions]);

  const handleBindDevice = useCallback(deviceInfo => {
    console.log('点击绑定设备', deviceInfo);
    setCurDevice(deviceInfo);
    setShowConfirm(true);
    reportClick({
      page_name: PAGE_NAME,
      button_name: 'bind_btn',
    });
    reportPop({
      page_name: PAGE_NAME,
      pop_name: 'bind_confirm_pop',
    });
  }, []);

  const handleChooseDeviceAgain = useCallback(() => {
    console.log('重新选择设备');
    setCurDevice(null);
    setShowConfirm(false);
    reportClick({
      page_name: PAGE_NAME,
      button_name: 'cancel_btn',
    });
  }, []);

  const handleConfimBindDevice = useCallback(() => {
    console.log('确定绑定设备', curDevice, curWelfareCard);
    const { rowID: curCardIndex, active_code } = curWelfareCard;
    const { sn, group_id } = curDevice;
    showLoadingToast();
    dispatch({
      type: 'rights/bindDeviceWithCode',
      payload: {
        gid: group_id,
        activeCode: active_code,
        deviceSn: sn,
      },
      callback: () => {
        handleUpdateCardInfo(curCardIndex, {
          code_status: USING_STATUS,
          red_dot: HIDE_RED_DOT,
        });
        Toast.hide();
        jsShowAppReviewDialog({ scene: 'welfare_code' });
        setShowDeviceModal(false);
        setShowConfirm(false);
      },
    });
    reportClick({
      page_name: PAGE_NAME,
      button_name: 'confirm_btn',
    });
  }, [curDevice, curWelfareCard]);

  const handleFilterOptionsChange = useCallback(
    current => {
      if (filterOptions.code_status === current) return;
      console.log('当前筛选状态是: ', current);
      setFilterOptions({
        ...filterOptions,
        page: 1,
        code_status: current,
      });
    },
    [filterOptions]
  );

  const renderDeviceTypes = useCallback(device_types => {
    if (!device_types || device_types.length === 0) return '--';
    return device_types.map(item => item.name).join(',');
  }, []);

  const row = useCallback((item, _, rowID) => {
    const {
      right_id,
      active_code,
      month_reward,
      months,
      activity_name,
      device_types,
      expiry_time,
      left_month,
      code_status,
      red_dot,
    } = item;
    return (
      <li className={styles['card-item-wrapper']}>
        <div
          className={`${styles['card-item']} ${styles[code_status]} ${
            red_dot === SHOW_RED_DOT ? styles['tag'] : ''
          }`}
          key={rowID}
          onClick={() => handleJumpToDetail(rowID, active_code)}
        >
          <div className={styles['card-info']}>
            <h3 className={`${styles['card-text']} ${styles['code']}`}>
              <i className={styles['copy-icon']} onClick={e => handleCopyCode(e, active_code)} />
              {active_code}
            </h3>
            <h4 className={styles['card-name']}>{activity_name || '--'}</h4>
            <p className={styles['card-text']}>可用设备：{renderDeviceTypes(device_types)}</p>
            <p className={styles['card-text']}>有效期至：{expiry_time}</p>
          </div>
          <div className={styles['card-action']}>
            <h4 className={styles['card-reward']}>
              {month_reward * 100}云豆<span className={styles['card-time']}>×{months}月</span>
            </h4>
            <button
              className={styles['card-btn']}
              disabled={code_status !== UNUSED_STATUS}
              onClick={e => handleUseCard(e, { code_status, active_code, right_id, rowID })}
            >
              {BTN_TEXT_MAP[code_status]}
            </button>
            {left_month > 0 && <p className={styles['note']}>剩余{left_month}月</p>}
          </div>
        </div>
      </li>
    );
  }, []);

  const handleGetWelareAdList = () => {
    dispatch({
      type: 'rights/getRightAdList',
      payload: {
        userType: 1,
        position: 2, // 1-加成卡位置 2-福利码位置
      },
      successCallback: data => {
        if (data?.length && data?.length > 0) {
          setAdData(data)
        }
      }
    });
  };

  useEffect(() => {
    if (filterOptions.page === 1) {
      window.scrollTo(0, 0);
      showLoadingToast();
    }
    getWelfareCodeList();
  }, [filterOptions]);

  useMounted(() => {
    reportPage({
      module: MODULE,
      page_name: PAGE_NAME,
    });
    handleGetWelareAdList();
  });

  return (
    <div className={styles['welfare-page']}>
      <CardStatusTabs
        curStatus={filterOptions.code_status}
        onStatusChange={handleFilterOptionsChange}
      />
      {/* 福利码广告位 */}
      {adData.length > 0 && <RecommendBonusCard baseData={adData}/>}

      {rightList.length > 0 ? (
        <ul className={styles['card-list']}>
          <ListView
            initialListSize={PAGE_SIZE}
            dataSource={dataSource}
            renderFooter={renderListFooter}
            // renderSeparator={separator}
            renderRow={row}
            pageSize={PAGE_SIZE}
            useBodyScroll
            scrollRenderAheadDistance={500}
            onEndReached={handleListEndReached}
            onEndReachedThreshold={10}
          />
        </ul>
      ) : (
        !loading && <NoData className={styles['noData']} />
      )}
      {isShowDeviceModal && (
        <DeviceModal
          onClose={() => setShowDeviceModal(false)}
          handleBindDevice={handleBindDevice}
          deviceList={deviceList}
        />
      )}
      <CustomModal
        visible={isShowConfirm}
        title="温馨提示"
        cancelText="重新选择"
        okText="继续绑定"
        cancelCallback={handleChooseDeviceAgain}
        okCallback={handleConfimBindDevice}
        needFixedBody={false}
      >
        <p className={styles['confirm-text']}>一经选定不可更改，是否确定绑定该设备？</p>
      </CustomModal>
    </div>
  );
};
export default connect(({ rights, loading }) => ({
  rights,
  loading: loading.effects['rights/getWelfareCodeList'],
}))(WelfareCard);
